var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "var(--Neutral-neutral-10, #F3F4F6)",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8745 9.74414H10.1245L11.1573 12.4792C11.3426 12.9697 10.9801 13.4941 10.4557 13.4941H7.54408C7.01962 13.4941 6.65713 12.9699 6.84239 12.4794L7.8745 9.74414ZM8.6245 11.2441L8.2495 11.9941H9.7495L9.3745 11.2441H8.6245Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2495 17.9941L8.2495 14.9941H9.7495L9.7495 17.9941H8.2495Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8736 16.5322L10.6255 14.6602L11.8736 13.8281L13.1217 15.7002L11.8736 16.5322Z",
    fill: "#696F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8774 15.7002L6.1255 13.8281L7.3736 14.6602L6.1255 16.5322L4.8774 15.7002Z",
    fill: "#696F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8915 3.43073C3.53618 2.93442 3.89093 2.24414 4.50132 2.24414H13.4975C14.1079 2.24414 14.4627 2.93439 14.1074 3.4307L10.1245 8.99414H7.8745L3.8915 3.43073ZM5.95677 3.74414L8.63534 7.49414H9.36341L12.042 3.74414H5.95677Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprayIcon);
export default __webpack_public_path__ + "static/media/spray_icon.d630df4b6bdc97a3bbf19e4a9c5851db.svg";
export { ForwardRef as ReactComponent };